export const baseUrl = `https://api-stg.jam-community.com`;
